/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

import { Consumer as CommunityContext } from '../../../contexts/CommunityContext';
import { getFormattedTimestamp } from '../../Utilities/TimeFunctions';
import Comment from '../Comment/Comment';

import CommentInput from '../CommentInput/CommentInput';
import { getFormattedLastEdit } from '../CommentList/CommentList';
import ReactionBar from '../SocialBar/SocialBar';

import './CommentComponent.scss';

/**
 * @deprecated
 */
export class CommentComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * object of comment { comment, hash, etc. }
         */
        comment: PropTypes.object.isRequired,
        /**
         * string hash of currently edited comment
         */
        activeEditingCommentHash: PropTypes.string,
        /**
         * string for truncating comment
         */
        mode: PropTypes.oneOf(['full', 'truncated']),
        /**
         * string location of where this is rendered
         * each has its own onReply action
         */
        location: PropTypes.oneOf(['Contributions', 'CommentList']),
        hideReactionBar: PropTypes.bool,
        isInMasterFeed: PropTypes.bool,
        isFirstComment: PropTypes.bool,
        parentUrl: PropTypes.string,
    };

    static defaultProps = {
        mode: 'full',
        location: 'CommentList',
        hideReactionBar: false,
    };

    getReactionBar = (hash) => {
        return (
            <CommunityContext>
                {(context) => (
                    <ReactionBar
                        {...ReactionBar.contextToProps(context, hash)}
                        onReply={this.handleReply(context)}
                        responseType="REPLY"
                    />
                )}
            </CommunityContext>
        );
    };

    handleReply = (context) => () => {
        switch (this.props.location) {
            case 'CommentList':
            default:
                return context.openCommentReply(this.props.comment.hash);
            case 'Contributions':
                return (window.location = this.props.comment.contentUrl);
        }
    };

    renderSingleComment = () => {
        const { comment, mode } = this.props;
        const { type, lastEditDate } =
            (comment.moderationOption && comment.moderationOption.status) || {};
        const isCommentEdited = type === 'edit';
        const truncateWithLink = !!(
            this.props.isInMasterFeed && this.props.isFirstComment
        );
        return this.singleComment(
            comment,
            mode,
            isCommentEdited,
            lastEditDate,
            truncateWithLink
        );
    };

    singleComment = (
        comment,
        mode,
        isCommentEdited,
        lastEditDate,
        truncateWithLink
    ) => (
        <Comment
            truncateWithLink={truncateWithLink}
            comment={comment.comment}
            mode={mode}
            author={comment.author}
            hash={comment.hash}
            isAnonymous={comment.isAnon}
            isInMasterFeed={this.props.isInMasterFeed}
            parentUrl={this.props.parentUrl}
            reactionBar={
                !this.props.hideReactionBar && this.getReactionBar(comment.hash)
            }
            formattedLastEdit={
                isCommentEdited
                    ? getFormattedLastEdit(lastEditDate, 'edited')
                    : ''
            }
            createdDate={getFormattedTimestamp(comment.contentDate)}
        />
    );

    renderEditCommentInput = () => {
        return (
            <CommentInput
                allowLabelOverride={false}
                buttonText="Publish"
                defaultIsAnonymous={!!this.props.comment.isAnon}
                label="Make anonymous"
                comment={this.props.comment.comment}
                onCancel={this.handleCancel}
                onSubmit={this.handlePublish}
            />
        );
    };

    handlePublish = (_, comment, anon) => {
        const payload = { comment, anon };

        this.props.onPublishComment(
            'community-comment',
            payload,
            this.props.activeEditingCommentHash
        );
        this.props.setEditingCommentHash(null);
    };

    handleCancel = () => {
        this.props.setEditingCommentHash(null);
    };

    render() {
        const { comment, activeEditingCommentHash } = this.props;

        return (
            <div className="component-Community-CommentComponent">
                {activeEditingCommentHash === comment.hash
                    ? this.renderEditCommentInput()
                    : this.renderSingleComment()}
            </div>
        );
    }
}

export default (props) => (
    <CommunityContext>
        {(context) => (
            <CommentComponent
                {...props}
                setEditingCommentHash={context.setEditingCommentHash}
                activeEditingCommentHash={context.editingCommentHash}
                onPublishComment={context.editCommunityContent}
            />
        )}
    </CommunityContext>
);
